import { FC, useContext, useRef, useState } from 'react';

import { Button, AddImageIcon, BucketIcon } from '@smartshell/ui-kit';

import { useUploadFile } from 'hooks';
import { LocalizationContext } from 'localization';
import notification from 'services/notificationService';

import s from './ImageUploaderField.module.scss';

interface IImageUploaderFieldProps {
  value: string;
  onChange: (value: string) => void;
  age?: number | null;
}

const FILE_MAXIMUM_SIZE = 307200;

export const ImageUploaderField: FC<IImageUploaderFieldProps> = ({
  value,
  onChange,
}) => {
  const { t } = useContext(LocalizationContext);
  const [isHovered, setIsHovered] = useState(false);
  const imgInput = useRef<HTMLInputElement>(null);

  const { uploadImage } = useUploadFile();

  return (
    <div className={s.container}>
      {value ? (
        <div
          style={{
            backgroundImage: `url("${value}")`,
          }}
          className={s['image-container']}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {/*{age !== null && <div className={s.age}>{age}+</div>}*/}
          {isHovered && (
            <div className={s['image-controls']}>
              <Button
                variant="ghost"
                className={s['delete-button']}
                onClick={() => onChange('')}
              >
                <BucketIcon color="error" size="m" />
              </Button>

              <Button onClick={() => imgInput.current?.click()} fullWidth>
                {t('change')}
              </Button>
            </div>
          )}
        </div>
      ) : (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
        <div
          className={s['default-image']}
          onClick={() => {
            imgInput.current?.click();
          }}
        >
          <AddImageIcon size="xxl" />
          {t('application.uploadImage')}
        </div>
      )}
      <input
        ref={imgInput}
        type="file"
        accept=".png, .jpg"
        className={s['file-input']}
        onChange={async (event) => {
          const file = event.target.files?.[0];

          if (!file || file.size > FILE_MAXIMUM_SIZE) {
            if (event.target) event.target.value = '';
            return notification.info({
              t,
              type: 'error',
              title: t('upload.file.error'),
              message: t('upload.file.error_2'),
            });
          }

          try {
            const imageUrl = await uploadImage(file);
            onChange(imageUrl);
          } catch (error: unknown) {
            if (error instanceof Error) {
              notification.info({
                t,
                type: 'error',
                title: t('upload.file.error'),
                message: error?.message,
              });
            } else {
              notification.info({
                t,
                type: 'error',
                title: t('upload.file.error'),
                message: String(error),
              });
            }
          }
        }}
      />
    </div>
  );
};
